import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { UserCircle2, LogIn } from "lucide-react";

// Small identity reassurance shown near purchase buttons so a customer always knows
// which account a purchase/download will be attached to (prevents stale-session buys).
export const CheckoutIdentityNote = ({ className = "" }) => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const switchAccount = async () => {
    await logout();
    navigate("/login");
  };

  if (user) {
    return (
      <div data-testid="checkout-identity-note" className={`flex items-start gap-3 bg-white/5 border border-white/10 px-4 py-3 text-sm ${className}`}>
        <UserCircle2 size={18} className="text-gold shrink-0 mt-0.5" />
        <div className="flex-1">
          <div className="text-gray-400">Signed in as</div>
          <div className="text-white font-medium break-all" data-testid="checkout-identity-email">{user.email}</div>
          <div className="text-gray-400 mt-1">Purchases and downloads will be added to this account.</div>
        </div>
        <button onClick={switchAccount} data-testid="switch-account-btn"
          className="shrink-0 text-gold text-xs font-semibold hover:underline whitespace-nowrap">
          Switch Account
        </button>
      </div>
    );
  }

  return (
    <div data-testid="checkout-identity-note-guest" className={`flex items-start gap-3 bg-white/5 border border-white/10 px-4 py-3 text-sm ${className}`}>
      <LogIn size={18} className="text-gold shrink-0 mt-0.5" />
      <div className="flex-1 text-gray-400">
        You're checking out as a guest. Use the same email at checkout, then{" "}
        <button onClick={() => navigate("/login")} data-testid="checkout-signin-link" className="text-gold font-semibold hover:underline">sign in</button>{" "}
        to access your downloads.
      </div>
    </div>
  );
};
